import { BaseRecord } from "./BaseRecord";
import { Client } from "./Client";

export class Tenant extends BaseRecord<number> {
    public name: string;
    public description!: string;
    public logo!: string;
    public isMainTenant: boolean = false;

    public clientId!: number;
    public client!: Client;

    constructor() {
        super();
        this.id = 0;
        this.name = "";
        this.description = "";
        this.logo = "";
        this.clientId = 0;
        this.client = new Client();
    }
}
